import { Theme } from '@mui/material';
import {
    getAccordion,
    getAlert,
    getAppBar,
    getBadge,
    getButton,
    getCard,
    getCssBaseline,
    getDrawer,
    getFab,
    getListItem,
    getListItemButton,
    getListItemIcon,
    getMenu,
    getSwitch,
    getToggleButton,
    getToggleButtonGroup,
    getTooltip,
    getTabs,
    getTable,
    getLink,
    getDialog,
    getChip,
    getAvatar,
    getSvgIcon,
} from '../components';
import { getIcon } from '@M3/components/Icon';

type M3Components = { components: Theme['components'] };

export const getMUIComponents = (theme: Theme) => {
    //const { palette } = theme;
    return {
        components: {
            ...getCssBaseline(theme),
            ...getAccordion(theme),
            ...getAlert(theme),
            ...getAppBar(theme),
            ...getBadge(theme),
            ...getToggleButton(theme),
            ...getToggleButtonGroup(theme),
            ...getButton(theme),
            ...getCard(theme),
            ...getDrawer(theme),
            ...getFab(theme),
            ...getIcon(theme),
            ...getListItem(theme),
            ...getListItemButton(theme),
            ...getListItemIcon(theme),
            ...getMenu(theme),
            ...getSwitch(theme),
            ...getSvgIcon(theme),
            ...getTooltip(theme),
            ...getTabs(theme),
            ...getTable(theme),
            ...getLink(theme),
            ...getDialog(theme),
            ...getChip(theme),
            ...getAvatar(theme),
        },
    } as M3Components;
};
